import {
  DropdownMenuItem as BaseDropdownMenuItem,
  DropdownMenuTrigger as BaseDropdownMenuTrigger,
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuLabel,
  DropdownMenuPortal,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from '@eazydraft/ui';
import React from 'react';

export {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuLabel,
  DropdownMenuPortal,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
};

type DropdownMenuTriggerProps = React.ComponentProps<typeof BaseDropdownMenuTrigger> & {
  asChild?: boolean;
};

function DropdownMenuTrigger({ asChild, children, ...props }: DropdownMenuTriggerProps) {
  if (asChild && React.isValidElement(children)) {
    return <BaseDropdownMenuTrigger render={children} {...props} />;
  }
  return <BaseDropdownMenuTrigger {...props}>{children}</BaseDropdownMenuTrigger>;
}

type DropdownMenuItemProps = React.ComponentProps<typeof BaseDropdownMenuItem> & {
  onSelect?: () => void;
};

function DropdownMenuItem({ onClick, onSelect, ...props }: DropdownMenuItemProps) {
  const handleClick = onClick ?? (onSelect ? () => onSelect() : undefined);
  return <BaseDropdownMenuItem onClick={handleClick} {...props} />;
}

export { DropdownMenuTrigger, DropdownMenuItem };
